import React, { useState } from "react";

const TabContent = ({ activeTab, tabData }) => {

  const user = localStorage.getItem('user');
  const firstLetter = user ? user.charAt(0).toUpperCase() : "?";
  // Find the content data for the active tab
  const contentData = tabData.find((tab) => Object.keys(tab)[0] === activeTab)[activeTab] || [];



  // Parse the feedback string into sections
  // const parseFeedback = (feedback) => {
  //   // const sections = {
  //   //   "My Strengths": [],
  //   //   "Areas for Improvement": [],
  //   //   "Suggestions for Improvement": [],
  //   // };
  
  //   // Split the feedback string into lines
  //   const lines = feedback.split("\n");
  //   let currentSection = null;
  //   const sections = {};

  //   lines.forEach((line) => {
  //     if (line.toLowerCase().includes("strengths")) {
  //       currentSection = "My Strengths";
  //     } else if (line.startsWith("**Areas for Improvement:**")) {
  //       currentSection = "Areas for Improvement";
  //     } else if (line.startsWith("**Suggestions for Improvement:**")) {
  //       currentSection = "Suggestions for Improvement";
  //     } else if (currentSection && line.trim() !== "") {
  //       if (!sections[currentSection]) {
  //         sections[currentSection] = [];
  //       }

  //       const match = line.match(/^(\d+\.)\s\*\*(.+?)\*\*/);
        
  //       if (match) {
  //         const number = match[1]; 
  //         const subheading = match[2];

  //         sections[currentSection].push({
  //           subheading: `${number} ${subheading}`,
  //           content: line.replace(match[0], "").trim(),
  //         });
  //       } else {
  //         if (sections[currentSection].length > 0) {
  //           sections[currentSection][sections[currentSection].length - 1].content +=
  //             "\n" + line.trim();
  //         }
  //       }
  //     }
  //   });
  
  //   return sections;
  // };
  const parseFeedback = (feedback) => {
    const sections = {
      "My Strengths": [],
      "Areas for Improvement": [],
      "Suggestions for Improvement": [],
    };
  
    // Process Strengths
    if (feedback.strengths) {
      Object.entries(feedback.strengths).forEach(([key, value], index) => {
        sections["My Strengths"].push({
          subheading: `${index + 1}. ${key}`,
          content: value.trim(),
        });
      });
    }
  
    // Process Areas for Improvement
    if (feedback.areas_of_improvement) {
      Object.entries(feedback.areas_of_improvement).forEach(([key, value], index) => {
        sections["Areas for Improvement"].push({
          subheading: `${index + 1}. ${key}`,
          content: value.trim(),
        });
      });
    }
  
    // Process Suggestions for Improvement
    if (feedback.suggestions_for_improvement) {
      Object.entries(feedback.suggestions_for_improvement).forEach(([key, value], index) => {
        sections["Suggestions for Improvement"].push({
          subheading: `${index + 1}. ${key}`,
          content: value.trim(),
        });
      });
    }
  
    return sections;
  };
  
  // Parse the feedback data if the active tab is "FeedBack"
  const feedbackSections =
    activeTab === "Feedback" && contentData.length > 0
      ? parseFeedback(contentData[0])
      : { "My Strengths": "", "Areas for Improvement": "", "Suggestions for Improvement": "" };

  // State to manage the active feedback tab
  const [activeFeedbackTab, setActiveFeedbackTab] = useState("My Strengths");

  return (
    <div className="h-auto w-full flex">
      {activeTab === "Feedback" ? (
        // Feedback Tab Styling and Content
        <div className="w-full h-full flex flex-col">
          {/* Feedback Sub-Tabs */}
          <div className="flex items-center justify-around space-x-4  h-[20%] bg-[#F6F6F6]">
            {Object.keys(feedbackSections).map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveFeedbackTab(tab)}
                className={`flex w-full h-full items-center justify-start lg:ps-6 lg:pe-10 ps-2  pe-2  ${
                  activeFeedbackTab === tab
                    ? "text-[#303972] lg:text-sm  text-xs font-semibold bg-white"
                    : "text-[#303972]  lg:text-sm text-xs font-semibold"
                }`}
                style={{ fontFamily:'sans-serif , Archivo'}}
              >
                {tab}
              </button>
            ))}
          </div>
          {/* Feedback Content */}
          <div className="p-2 h-full m-5" style={{  overflowY: "auto" }}>
          {feedbackSections[activeFeedbackTab] ? (
              <div className="text-[#303972] whitespace-pre-line ">
                {feedbackSections[activeFeedbackTab].map((item, index) => (
                  <div key={index} className="mb-4">
                    {/* <p className="font-semibold text-sm"
                    style={{
                      fontFamily:'sans-serif, Archivo'
                    }}>{item.subheading}</p> */}
                    <p className="mt-1 text-sm"
                    style={{
                      fontFamily:"sans-serif, Archivo"
                    }}>{item.content}</p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center h-full w-full">
                <img
                  src="/images/No_Search_Result.svg"
                  alt="No results"
                  className="mx-auto mb-4"
                  style={{ width: "200px", height: "auto" }}
                />
                <p className="text-[#8A9ABE]">
                  No feedback available for this section.
                </p>
              </div>
            )}
          </div>
        </div>
      ) : (
        // Transcription Tab Styling and Content
        <div className="w-full h-full box-border pt-5" style={{ maxHeight: "430px", overflowY: "auto" }}>
          {contentData.length > 0 ? (
            contentData.map((item, index) => (
              <div key={index} className="ps-5 pe-5 flex ">
                <div className="flex flex-col items-center mr-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#008B9A] text-white rounded-full border-l-2 border-[#009FB1]">
                    {firstLetter} 
                  </div>
                  <div className="w-[2px] flex-grow border-l-2 border-dashed border-[#009FB1]"></div>
                </div>
                <div>
                  <p className="text-[#303972]  p-2 ps-0 pt-1">{item.content}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center">
              <img
                src="/images/No_Search_Result.svg"
                alt="No results"
                className="mx-auto mb-4"
                style={{ width: "200px", height: "auto" }}
              />
              <p className="text-[#8A9ABE]">
                Start recording or upload a video to view your communication analysis.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TabContent;